import { useTopOfPageContent } from "@faire/retailer-visitor-shared/stores/ui/useTopOfPageContent";
import { debounceIfPossible } from "@faire/web/common/globals/debounceIfPossible";
import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
import { useMemo, useRef } from "react";

export const useCategoryPageScroll = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const filterRef = useRef<HTMLDivElement>(null);

  const { headerPlusPromoBannerHeight } = useTopOfPageContent();

  const scrollToTop = useMemo(
    () =>
      debounceIfPossible((params: { toResults?: boolean; toTop?: boolean }) => {
        const height = headerPlusPromoBannerHeight;
        let offsetTop = 0;
        if (params.toTop) {
          offsetTop = 0;
        } else if (params.toResults && filterRef.current?.offsetTop) {
          offsetTop = filterRef.current.offsetTop - height;
        } else if (scrollRef.current?.offsetTop) {
          offsetTop = scrollRef.current.offsetTop - height;
        }
        getWindowOrThrow().scrollTo?.({
          top: offsetTop,
          left: 0,
          behavior: "smooth",
        });
      }, 100),
    [headerPlusPromoBannerHeight]
  );

  return {
    scrollRef,
    filterRef,
    scrollToTop,
  };
};
